import type { QrCode } from './api/types';

/**
 * A personal space is stored as a group whose name is an internal key, never shown. The API sends its owner's
 * name instead, which only matters to a super admin reading somebody else's.
 */
export function ownerGroupLabel(
  qrCode: Pick<QrCode, 'inPersonalSpace' | 'ownerGroupId' | 'ownerGroupName'>,
  t: (key: string, options?: Record<string, unknown>) => string,
  myPersonalSpaceId: string | null | undefined,
): string {
  if (!qrCode.inPersonalSpace) {
    return qrCode.ownerGroupName;
  }

  return qrCode.ownerGroupId === myPersonalSpaceId || !qrCode.ownerGroupName
    ? t('qrCode.personalSpace')
    : t('qrCode.personalSpaceOf', { name: qrCode.ownerGroupName });
}
